const common = {
  nav_home: 'الرئيسية',
  nav_about_turkey: 'عن تركيا',
  nav_turkey_culture: 'الثقافة في تركيا',
  nav_health_institutions: 'المؤسسات الصحية',
  nav_agencies: 'وكالات السياحة الصحية',
  nav_contact: 'اتصل بنا',

  nav_login: 'تسجيل الدخول',
  nav_register: 'إنشاء حساب',
  nav_user_login: 'دخول المستخدم',
  nav_user_login_desc: 'الوصول إلى لوحة الأعضاء',
  nav_institution_login: 'دخول المؤسسة',
  nav_institution_login_desc: 'الوصول إلى لوحة المؤسسة',
  nav_admin_login: 'دخول المشرف',
  nav_admin_login_desc: 'إدارة المنصة',
  nav_my_panel: 'لوحتي',
  nav_institution_panel: 'لوحة المؤسسة',
  nav_admin_panel: 'لوحة المشرف',
  nav_user_panel: 'لوحة المستخدم',
  nav_institution_label: 'مؤسسة',
  nav_admin_label: 'مشرف',
  nav_user_label: 'مستخدم',
  nav_logout: 'تسجيل الخروج',
  nav_warning_title: 'تنبيه مهم',
  nav_warning_text: 'منصة Health Travel Türkiye هي منصة رقمية تجمع بين الأشخاص المحتاجين إلى خدمات صحية والمرافق الصحية ووكالات السياحة الصحية التي تقدم خدمات صحية دولية. يتم تقديم خدمات السياحة الصحية على هذه المنصة. المؤسسات الصحية معتمدة ومرخصة من قبل السلطات المختصة في البلد المعني. هذه المنصة لأغراض إعلامية فقط ولا تحتوي على أي تشخيص طبي أو توصيات علاجية أو توجيه صحي. مشغل المنصة لا يتحمل أي مسؤولية تجارية أو طبية. يرجى استشارة طبيب متخصص لمشاكلك الصحية.',

  footer_description: 'الوصول إلى المؤسسات الصحية المعتمدة المرخصة من وزارة الصحة التركية. استعد صحتك بأمان وسرعة.',
  footer_quick_links: 'روابط سريعة',
  footer_for_institutions: 'للمؤسسات',
  footer_institution_login: 'دخول المؤسسة',
  footer_register: 'إنشاء حساب',
  footer_contact: 'اتصل بنا',
  footer_email_label: 'البريد الإلكتروني',
  footer_address_label: 'العنوان',
  footer_address_value: 'إسطنبول، تركيا',
  footer_rights: 'جميع الحقوق محفوظة.',
  footer_privacy: 'سياسة الخصوصية',
  footer_kvkk: 'نص إفصاح KVKK',
  footer_terms: 'شروط الاستخدام',
  footer_powered: 'Powered by Readdy',
  footer_newsletter_title: 'ابق على اطلاع',
  footer_newsletter_desc: 'اشترك للحصول على آخر أخبار السياحة الصحية في تركيا.',
  footer_newsletter_placeholder: 'عنوان بريدك الإلكتروني',
  footer_newsletter_btn: 'اشتراك',
  footer_newsletter_sending: 'جار الإرسال...',
  footer_newsletter_success: 'شكراً! تم اشتراكك بنجاح.',
  footer_newsletter_error: 'حدث خطأ. يرجى المحاولة مرة أخرى.',

  loading: 'جار التحميل...',
  search: 'بحث',
  filter: 'تصفية',
  clear: 'مسح',
  clear_all: 'مسح الكل',
  all: 'الكل',
  view_all: 'عرض الكل',
  view_details: 'عرض التفاصيل',
  explore: 'استكشاف',
  back: 'رجوع',
  save: 'حفظ',
  cancel: 'إلغاء',
  submit: 'إرسال',
  send: 'إرسال',
  sending: 'جار الإرسال...',
  success: 'نجاح',
  error: 'خطأ',
  no_results: 'لا توجد نتائج',
  approved: 'معتمد',
  pro_member: 'PRO',
  doctor_count: '{{count}} طبيب',
  verified: 'موثق',
  accreditation: 'اعتماد',
  official_accreditation: 'الاعتماد الرسمي والضمان',
  health_turkey: 'Health Türkiye',
  health_turkey_desc: 'منصة السياحة الصحية',
  ministry_health: 'وزارة الصحة في جمهورية تركيا',
  ministry_health_desc: 'مؤسسة صحية معتمدة',
  ministry_culture: 'وزارة الثقافة والسياحة في جمهورية تركيا',
  ministry_culture_desc: 'شهادة ترخيص السياحة الصحية',
  user_type: 'مستخدم',
  institution_type: 'مؤسسة',
  admin_type: 'مشرف',

  // Breadcrumb names (Schema.org JSON-LD)
  breadcrumb_home: 'الرئيسية',
  breadcrumb_contact: 'اتصل بنا',
  breadcrumb_institutions: 'المؤسسات الصحية',
  breadcrumb_agencies: 'وكالات السياحة الصحية',
  breadcrumb_about_turkey: 'عن تركيا',
  breadcrumb_turkey_culture: 'الثقافة التركية',
  breadcrumb_kvkk: 'KVKK',
  breadcrumb_privacy: 'سياسة الخصوصية',
  breadcrumb_terms: 'شروط الاستخدام',

  // SEO meta — page titles & descriptions
  seo_home_title: 'Health Travel Türkiye - منصة السياحة الصحية في تركيا',
  seo_home_desc: 'اكتشف المؤسسات الصحية المعتمدة في تركيا للمرضى الدوليين. زراعة الشعر، علاج الأسنان، الجراحة التجميلية، أطفال الأنابيب والمزيد.',
  seo_turkiye_title: 'عن تركيا - دليل السفر | Health Travel Türkiye',
  seo_turkiye_desc: 'دليل سفر شامل عن تركيا: المدن والمواقع التاريخية والعجائب الطبيعية والمعلومات العملية للسفر.',
  seo_kultur_title: 'الثقافة التركية - التقاليد والمطبخ والحياة | Health Travel Türkiye',
  seo_kultur_desc: 'اكتشف التراث الثقافي الغني لتركيا: التقاليد والمطبخ والمهرجانات وثقافة الحمام والتسوق والحياة الاجتماعية.',
  seo_contact_title: 'اتصل بنا - Health Travel Türkiye',
  seo_contact_desc: 'تواصل مع Health Travel Türkiye. تواصل معنا لأي استفسارات حول السياحة الصحية في تركيا.',
  seo_kvkk_title: 'نص إفصاح KVKK - حماية البيانات الشخصية | Health Travel Türkiye',
  seo_kvkk_desc: 'حماية البيانات الشخصية ونص إفصاح KVKK لـ Health Travel Türkiye.',
  seo_privacy_title: 'سياسة الخصوصية - أمان البيانات الشخصية | Health Travel Türkiye',
  seo_privacy_desc: 'سياسة الخصوصية ومبادئ أمان البيانات الشخصية لـ Health Travel Türkiye.',
  seo_terms_title: 'شروط الاستخدام - قواعد المنصة | Health Travel Türkiye',
  seo_terms_desc: 'شروط الاستخدام واتفاقية المستخدم لـ Health Travel Türkiye.',

  seo_institutions_title: 'المؤسسات الصحية في تركيا | Health Travel Türkiye',
  seo_institutions_desc: 'قارن المؤسسات الصحية المعتمدة في تركيا. ابحث عن أفضل العيادات لزراعة الشعر وعلاج الأسنان والجراحة التجميلية وأطفال الأنابيب والمزيد.',
  seo_agencies_title: 'وكالات السياحة الصحية | Health Travel Türkiye',
  seo_agencies_desc: 'ابحث عن وكالات السياحة الصحية التي تنظم رحلتك الطبية والإقامة واحتياجات السفر في تركيا.',
  seo_register_title: 'إنشاء حساب - انضم إلى Health Travel Türkiye',
  seo_register_desc: 'أنشئ حسابك على Health Travel Türkiye. سجل كمريض أو مؤسسة صحية للوصول إلى جميع الميزات.',
};

export default common;
